import React from 'react';
import { Box, Typography } from '@mui/material';

const Analytics = () => {
  // Placeholder for future real analytics integration
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Analytics
      </Typography>
      <Typography variant="body1">Total Queries: 100 (placeholder)</Typography>
      <Typography variant="body1">Bad Ratings: 5% (placeholder)</Typography>
      <Typography variant="body1">Other stats to come...</Typography>
    </Box>
  );
};

export default Analytics;
